export default {
  PER_PAGE: 10,
  MARGIN: 1,
  RANGE: 3,
};
